<template>
  <div>
    <Layout />
    <v-container grid-list-md>
      <notifications position="bottom center" />
      <v-layout row wrap>
        <v-flex xs12>
          <v-toolbar flat color="white" class="elevation-1">
            <v-toolbar-title>Clientes</v-toolbar-title>
            <v-divider class="mx-2" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              v-model.lazy="search"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
              class="hidden-md-and-down"
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark class="mb-2" @click="openClientForm({})"
              >Novo</v-btn
            >
          </v-toolbar>

          <v-data-table
            :headers="columns"
            :items="items"
            :loading="loading"
            hide-default-footer
            class="elevation-1"
          >
            <template v-slot:item.action="{ item }">
              <v-icon small class="mr-2" @click="openClientForm(item)">
                edit
              </v-icon>
              <v-icon small class="mr-2" @click="openAddressForm(item)">
                place
              </v-icon>
              <v-icon small @click="deleteItem(item)"> delete </v-icon>
            </template>
            <template slot="no-data">
              Desculpe, nenhum dado para ser exibido!
            </template>
          </v-data-table>
          <div class="text-xs-center pt-2">
            <v-pagination
              v-model="pagination.page"
              :length="pages"
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>

      <div v-if="clientFormActive.open">
        <client-form
          :active="clientFormActive.open"
          :item="clientFormActive.item"
          :finish="onCloseClientForm"
        ></client-form>
      </div>

      <div v-if="addressFormActive.open">
        <palce-form
          :active="addressFormActive.open"
          :item="addressFormActive.item"
          :finish="onCloseAddressForm"
        ></palce-form>
      </div>
    </v-container>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  data() {
    return {
      search: "",
      pagination: {
        totalItems: 0,
        rowsPerPage: 10,
        ascending: false,
        page: 1,
        sortBy: "id",
      },
      items: [],
      columns: [
        { value: "id", text: "ID" },
        { value: "name", text: "Nome" },
        { value: "phone", text: "Telefone" },
        { value: "email", text: "Email" },
        { text: "", value: "action", sortable: false },
      ],
      clientFormActive: { open: false, item: {} },
      addressFormActive: { open: false, item: {} },
      loading: false,
    };
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
  },
  watch: {
    "pagination.page": {
      handler() {
        this.getList();
      },
      deep: true,
    },
    search: function () {
      this.debounceInput();
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.getList();
    },
    getList() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const params = {
          ...this.pagination,
          totalItems: undefined,
          search: this.search,
        };
        this.$http
          .get(`/clients/list`, { params })
          .then((response) => response.data)
          .then((json) => {
            setTimeout(() => {
              this.loading = false;
              this.items = json.items;
              this.pagination.totalItems = json.total;
            }, 1000);
          })
          .catch(() => (this.loading = false));
      });
    },
    openClientForm(item) {
      this.clientFormActive.open = true;
      this.clientFormActive.item = item;
    },
    onCloseClientForm() {
      this.clientFormActive.open = false;
      this.getList();
    },
    openAddressForm(item) {
      this.addressFormActive.open = true;
      this.addressFormActive.item = item;
    },
    onCloseAddressForm() {
      this.addressFormActive.open = false;
      this.getList();
    },
    deleteItem(item) {
      console.log(item.id);

      if (confirm(`Deseja realmente excluir ${item.name}?`)) {
        this.$http.delete(`/clients/${item.id}`).then((response) => {
          this.$notify({
            title: `Cliente Excluido!`,
            type: "error",
          });
          this.getList();
        });
      }
    },
    debounceInput: _.debounce(function () {
      setTimeout(() => {
        this.getList();
      }, 200);
    }, 400),
  },
};
</script>
